import React from "react";

const ADO_Parameter = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Parameter</h1>
      <p>This is the ADO Parameter page content.</p>
    </div>
  );
};

export default ADO_Parameter;
